import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeCollectionPath } from '~data/selectors/collections';

export default function CollectionItemTitle({ title, _id, parentId, level }) {
  const getCollectionPath = useMemo(() => makeCollectionPath(), []);
  const _path = useSelector((state) =>
    !level && parentId ? getCollectionPath(state, _id) : undefined,
  );

  if (_path)
    return (
      <span className='block truncate text-left [direction:rtl]'>
        <span className='text-muted-foreground [direction:ltr] [unicode-bidi:embed]'>
          {_path.map(({ title }) => title).join(' / ')} /
        </span>
        &nbsp;
        <span className='[direction:ltr] [unicode-bidi:embed]'>
          {title}
        </span>
      </span>
    );

  return title;
}
